import React from "react";

import { cv } from "~/tools/class-variance";

import type { BorgAgentType } from "../models/borg-types";

const agentTypeStyles = {
	chat: "border-grey-300 bg-grey-100 text-grey-700",
	investigation: "border-primary-200 bg-primary-100 text-primary-700",
	promql_assist: "border-primary-200 bg-primary-100 text-primary-700",
	docs_assist: "border-grey-300 bg-grey-100 text-grey-700",
};

const agentBadgeVariants = cv("whitespace-nowrap rounded-full border px-2 py-0.75 font-medium text-10 shadow-sm", {
	variants: { agentType: agentTypeStyles },
});

type StyledAgentType = keyof typeof agentTypeStyles;
const isStyledAgentType = (v: BorgAgentType): v is StyledAgentType => v in agentTypeStyles;

export const AgentTypeBadge: React.FC<{ agentType: BorgAgentType; label: string }> = ({ agentType, label }) => (
	<span
		className={agentBadgeVariants({
			className: undefined,
			agentType: isStyledAgentType(agentType) ? agentType : "chat",
		})}
	>
		{label}
	</span>
);
